const PROD_HOST = 'vzhik.yandex-team.ru';
const TEST_HOST = 'vzhik-test.yandex-team.ru';
const API_URL = `https://${location.hostname === PROD_HOST ? PROD_HOST : TEST_HOST}/api`;

export const VIDEOS_URL = `${API_URL}/videos`;
export const PROFILES_URL = `${API_URL}/profiles`;
export const USER_INFO_URL = `${API_URL}/my-profile`;

const PROD_PLAYER_HOST = 'runtime.strm.yandex-team.ru';
const TEST_PLAYER_HOST = 'runtime.tst.strm.yandex-team.ru';
export const PLAYER_URL = `https://${
    location.hostname === PROD_HOST ? PROD_PLAYER_HOST : TEST_PLAYER_HOST
}/player/video`;
